import { h } from "preact"
import { useEffect, useState } from "preact/hooks";
import { CSSProperties } from "styled-components";
import { useQuery } from "../../hooks/useQuery";
import { StyledButtonSecondary } from "./styled"

interface IPrimaryButton {
    label: string;
    style?: CSSProperties;
    mobileStyle?: CSSProperties;
    tabletStyle?: CSSProperties;
    isLoading?: boolean;
    forceLoading?: boolean;
    onPress?(): Promise<void> | boolean | void;
}

export const SecondaryButton = ({
    label,
    style,
    mobileStyle,
    tabletStyle,
    isLoading,
    forceLoading,
    onPress
}: IPrimaryButton) => {
    const { isMobile, isTablet } = useQuery();
    const [loading, setLoading] = useState(forceLoading);

    useEffect(() => {
        setLoading(forceLoading)
    }, [forceLoading])

    const onPressButton = async () => {
        isLoading && setLoading(true);
        onPress && await onPress();
        isLoading && setLoading(false);
    }

    const s = isMobile ? mobileStyle : isTablet ? tabletStyle : style
    return <StyledButtonSecondary style={s} loading={loading} onClick={onPressButton}>
        {label}
    </StyledButtonSecondary>
}